enum TaxonomyDataType {
  Image = 10,
  ImageList = 15,
  Video = 17,
  Text = 20,
  TextList = 25,
  Number = 30,
  Condition = 40,
  Color = 50,
  PageURL = 60,
  Date = 70,
  DateList = 75,
  DateTime = 80,
  Font = 85,
  Subtitles = 90,
  Audio = 100,
}

enum TaxonomyType {
  Product = 'Product',
  Location = 'Location',
  Content = 'Content',
  Metric = 'Metric',
  FirstParty = 'UserProfile',
}

enum TaxonomyFieldName {
  Id = 'id',
}

export {TaxonomyDataType, TaxonomyType, TaxonomyFieldName};
